import {Pipe, PipeTransform} from '@angular/core';

/***
 * This function traverses an object with a given path and returns the found value.
 * @param obj The object a value should be retrieved from.
 * @param path The path to the desired value. (for example: 'membership.name')
 */
export function traverse(obj: any, path: string) {
  return path.split('.').reduce((cur, key) => {
    return cur?.[key];
  }, obj);
}

@Pipe({name: 'stringFilter'})
export class StringFilterPipe implements PipeTransform {
  transform(value: unknown[], filters: {property: string, value: string}[]): unknown[] {
    if (value == null) {
      return value;
    }

    filters.forEach(filter => {
      value = value.filter(v => {
        if (filter.value != null) {
          return (traverse(v, filter.property) as string).toLowerCase().includes(filter.value.toLowerCase());
        } else {
          return true;
        }
      });
    });

    return value;
  }
}
